import { errorMessage } from 'constants/CommonConstants';
import { PHONE_REGEX } from 'constants/Regex';
import { formPatternRules, formRequiredRules } from 'helper';
import React, { useEffect, useImperativeHandle } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { StepperFromProps } from 'sharedComponents/dynamicStepperForm/dynamicStepperFormInterface';
import { CommonPhoneInput } from 'sharedComponents/inputGroup/CommonPhoneInput';

const PhoneNumberInputComponent: React.ForwardRefRenderFunction<unknown, StepperFromProps> = (
  { onNext, onBack },
  ref
) => {
  const { t } = useTranslation();
  const hasCalledNextStep = React.useRef(false);

  const { control, trigger, getValues, setValue } = useFormContext();

  useEffect(() => {
    const { phone } = getValues();
    setValue('confirmMobile', phone);
  }, []);

  const nextStep = async () => {
    if (hasCalledNextStep.current) return;
    hasCalledNextStep.current = true;

    onNext?.();
  };

  const backStep = () => {
    onBack?.();
  };

  useImperativeHandle(ref, () => ({
    nextStep,
    backStep,
  }));

  return (
    <>
      <div className='trade-in-stepper__otp-form__content text-center'>
        <h4 className='trade-in-stepper__otp-form__content__title'>{t('stepperFormTradeIn.mobileVerification')}</h4>
        <p>{t('stepperFormTradeIn.note5')}</p>
      </div>
      <div className='form-group'>
        <CommonPhoneInput
          name='confirmMobile'
          control={control}
          label={t('stepperFormTradeIn.confirmPhoneLabel')}
          placeholder={t('stepperFormTradeIn.confirmPhonePlaceholder')}
          rules={{
            ...formRequiredRules(errorMessage(t).phoneRequired),
            ...formPatternRules(PHONE_REGEX, errorMessage(t).invalidPhoneFormat),
          }}
          triggerValidationForField={trigger}
        />
      </div>
    </>
  );
};

const PhoneNumberInputComponentStep = React.forwardRef(PhoneNumberInputComponent);

export default PhoneNumberInputComponentStep;
